import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import YourHeylinkSite from 'components/dashboard/earn-content/adsense/YourHeylinkSite';
import CommonInputField from 'components/elements/inputs/CommonInputField';
import AdsenseInfoIcon from 'components/dashboard/earn-content/adsense/AdsenseInfoIcon';

import './GoogleAdsenseSettings.css';


function GoogleAdsenseSettings(props) {
  const {
    me,
    patchUser,
    setIdChanged,
    patchUserSuccess,
    patchUserError,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (patchUserSuccess && patchUserSuccess.adsense_publisher_id) {
      setIdChanged(true);
    }
  }, [patchUserSuccess]);

  const validation = value => {
    if (value && !value.match(/pub-[0-9]{16}$/)) {
      return t("Wrong publisher ID. Format is: pub-1234567890987654");
    }
    return null;
  };

  return (
    <div className="google-adsense-settings__component">
      <YourHeylinkSite />
      <div className="form-wrapper">
        <div className="label">
          <div className="text">
            {t("You can change your")} <strong>{t("AdSense Publisher ID")}</strong>
          </div>
          <AdsenseInfoIcon />
        </div>
        <CommonInputField
          key="google-adsense-publisher-id-input-key"
          placeholder="pub-0123456789XXXXXX"
          initialValue={me.adsense_publisher_id}
          executedFunction={value => {
            const form = new FormData();
            form.append('adsense_publisher_id', value);
            patchUser(form);
          }}
          serverErrors={patchUserError && patchUserError.adsense_publisher_id}
          validationFunction={validation}
        />
      </div>
    </div>
  );
}

GoogleAdsenseSettings.propTypes = {
  patchUser: PropTypes.func.isRequired,
  setIdChanged: PropTypes.func.isRequired,
  patchUserSuccess: PropTypes.object,
  patchUserError: PropTypes.object,
  me: PropTypes.object,
};

GoogleAdsenseSettings.propTypes = {
  patchUserSuccess: null,
  patchUserError: null,
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(GoogleAdsenseSettings);
